import http from './http'

export async function getProfile() {
  const { data } = await http.get('/api/account/me')
  return data
}

/*  PUT /api/account/profile/update */
export async function updateProfile({
  username,
  firstName,
  lastName,
  email,
  phoneNumber,
  profileImageUrl,
}) {
  const payload = { username, firstName, lastName, email, phoneNumber, profileImageUrl }
  const { data } = await http.put('/api/account/profile/update', payload)
  return data
}

/* PUT /api/account/change-password */
export async function changePassword(currentPassword, newPassword) {
  const { data } = await http.put('/api/account/change-password', {
    currentPassword,
    newPassword,
  })
  return data
}

/* PUT /api/account/change-email */
export async function changeEmail(newEmail, password) {
  const { data } = await http.put('/api/account/change-email', {
    newEmail,
    password,
  })
  return data
}

/* POST /api/account/upload-profile-image */
export async function uploadProfileImage(file) {
  const fd = new FormData()
  fd.append('image', file)

  const { data } = await http.post('/api/account/upload-profile-image', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export const updateMe = (p) => updateProfile(p)
export const uploadAvatar = (file) => uploadProfileImage(file)
export const getMe = () => getProfile()
